<template>
  <span>
    <div v-if="Object.keys(getUserInfo).length !== 0">
      <DashboardPerfil :user-data="getUserInfo"></DashboardPerfil>
    </div>
    <div v-else>
      <v-overlay z-index="4">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </div>
  </span>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  components: {
    DashboardPerfil: () => import("@/components/user/CuerpoPerfil.vue")
  },
  data: function() {
    return {
      user: {}
    };
  },
  methods: {
    ...mapActions("user", ["getProfileInfo"])
  },
  computed: {
    ...mapGetters("user", ["getUserInfo", "fetching"])
  },
  mounted: async function() {
    if (Object.keys(this.user).length === 0 && !this.fetching)
      await this.getProfileInfo();
  }
};
</script>
